/* eslint-disable indent */
/* eslint-disable no-use-before-define */
import {
  Combobox,
  CurrencyInput,
  DatePicker,
  HugerteEditor,
  MaskInput,
  NumberInput,
  RadioInput,
  Select,
  TextareaInput,
  TextInput,
  Tickbox,
} from 'components/FormControl';
import MultipleSelect from 'components/FormControl/MultipleSelect';
import { HTML_TAGS, INPUT_TYPES } from 'constant/dynamic-type';
import Signature from 'features/PrequalificationReview/components/Signature';
import * as Yup from 'yup';
import { unflatten } from 'flat';

let control;
let errors;
let reset;
let watch;
let setValue;
let refetchReviewerInfo;
let reviewerInfo;
let existedData;
let readOnly = false;

export const initialValues = (opts) => {
  const {
    control: _control,
    errors: _errors,
    reset: _reset,
    watch: _watch,
    setValue: _setValue,
    refetchReviewerInfo: _refetchReviewerInfo,
    reviewerInfo: _reviewerInfo,
    existedData: _existedData,
    readOnly: _readOnly,
  } = opts;
  control = _control;
  errors = _errors;
  reset = _reset;
  watch = _watch;
  setValue = _setValue;
  refetchReviewerInfo = _refetchReviewerInfo;
  reviewerInfo = _reviewerInfo;
  existedData = _existedData;
  readOnly = _readOnly;
};

export const functions = {
  checkOnlyOne: (opts) => {
    const { name } = opts;
    const generalName = name.split('.').slice(0, -1).join('.');
    const specificName = name.split('.').slice(-1).join('.');
    const generalValue = watch(generalName);
    if (!generalValue) return;
    if (generalValue[specificName]) {
      Object.keys(generalValue).forEach((key) => {
        if (key !== specificName) {
          setValue(`${generalName}.${key}`, false);
        }
      });
    }
  },
  calculateTotalPoints: (opts) => {
    const name = opts.name || opts;
    let value = 0;
    const generalName = name.split('.').slice(0, -1).join('.');
    const specificName = name.split('.').slice(-1).join('.');
    const generalValue = watch(generalName);
    if (!generalValue) return;
    Object.keys(generalValue).forEach((key) => {
      if (key !== specificName) {
        if (typeof generalValue[key] === 'number') {
          value += generalValue[key] || 0;
        }
        if (typeof generalValue[key] === 'object') {
          value += existedData[generalName]?.[key]?.totalPoints || 0;
        }
      }
    });
    if (value > 100) {
      value = 100;
    }
    existedData[name] = value;
    existedData = unflatten(existedData);
  },
  calculateOneRowTotalBudget: (opts) => {
    const name = opts.name || opts;
    const oldValue = watch(name);
    let value = 0;
    const oneRowKey = name.split('.').slice(0, -1).join('.');
    const totalKey = name.split('.').slice(-1).join('.');
    const objecSubKeys = watch(oneRowKey);
    if (!objecSubKeys) return;
    Object.keys(objecSubKeys).forEach((key) => {
      if (key !== totalKey) {
        if (typeof objecSubKeys[key] === 'number') {
          value += objecSubKeys[key] || 0;
        }
      }
    });
    existedData[name] = value;
    existedData = unflatten(existedData);
    if (value !== oldValue) {
      setValue(name, value);
    }
  },
  calculateOneColumnTotalBudget: (opts) => {
    const name = opts.name || opts;
    let value = 0;
    const oldValue = watch(name);
    const pathParts = name.split('.');
    if (pathParts.length < 3) return; // ít nhất vẫn cần expenditure.total.xxx

    const rootKey = pathParts[0]; // expenditure
    const totalKey = pathParts[1]; // total
    const columnKey = pathParts.slice(2).join('.'); // stateBudget hoặc percentage.otherSources

    const rootData = watch(rootKey); // toàn bộ expenditure

    if (!rootData) return;

    const keysToSum = Object.keys(rootData).filter((k) => k !== totalKey);

    keysToSum.forEach((key) => {
      const node = rootData[key];
      if (node && typeof node === 'object') {
        // truy cập value bằng columnKey, dù có nhiều cấp vẫn hỗ trợ
        const columnValue = columnKey.split('.').reduce((acc, cur) => acc && acc[cur], node);
        if (typeof columnValue === 'number') {
          value += columnValue;
        }
      }
    });

    existedData[name] = value;
    existedData = unflatten(existedData);

    if (value !== oldValue) {
      setValue(name, value);
    }
  },
};
export const setUndefinedToNull = (obj) => {
  const result = { ...obj };
  Object.keys(result).forEach((key) => {
    if (result[key] === undefined) {
      result[key] = null;
    } else if (typeof result[key] === 'object' && result[key] !== null) {
      result[key] = setUndefinedToNull(result[key]);
    }
  });
  return result;
};
export const getValueByPath = (obj, path, fallback = '') =>
  path.split('.').reduce((acc, key) => acc?.[key], obj) ?? fallback;
// types: ['html', 'text' , 'commbobox', 'currencyInput', 'fileInput',
// 'datePicker', 'editorInput', 'maskInput', 'multipleSelect', 'numberInput', 'radioInput',
//  'select', 'textAreaInput', 'textInput', 'tickBox']
export const handleTagName = (tagName, className, children, func, value) => {
  switch (tagName) {
    case HTML_TAGS.H1:
      return <h1 className={className}>{children}</h1>;
    case HTML_TAGS.H2:
      return <h2 className={className}>{children}</h2>;
    case HTML_TAGS.H3:
      return <h3 className={className}>{children}</h3>;
    case HTML_TAGS.H4:
      return <h4 className={className}>{children}</h4>;
    case HTML_TAGS.H5:
      return <h5 className={className}>{children}</h5>;
    case HTML_TAGS.H6:
      return <h6 className={className}>{children}</h6>;
    case HTML_TAGS.P:
      return <p className={className}>{children}</p>;
    case HTML_TAGS.A:
      return (
        <a
          className={className}
          href={value.href}
          target={value.target || '_blank'}
          rel="noopener noreferrer"
        >
          {children}
        </a>
      );
    case HTML_TAGS.SPAN:
      return <span className={className}>{children}</span>;
    case HTML_TAGS.LABEL:
      return (
        <label className={className} htmlFor={children.for}>
          {children.value}
        </label>
      );
    case HTML_TAGS.UL:
      return <ul className={className}>{children}</ul>;
    case HTML_TAGS.OL:
      return <ol className={className}>{children}</ol>;
    case HTML_TAGS.LI:
      return <li className={className}>{children}</li>;
    case HTML_TAGS.DIV:
      return (
        <div className={className} onClick={() => (func ? func(value) : null)}>
          {children}
        </div>
      );
    default:
      return children;
  }
};
export const handleTable = (tableData, className, style) => (
  <table className={className || 'p-datatable-table form-table'} style={style}>
    <thead>
      <tr>
        {tableData.headers.map((header) => (
          <th
            key={header.label}
            className={header.class || tableData.headersClass}
            rowSpan={header.rows || 1}
            colSpan={header.cols || 1}
            style={header.style}
          >
            {handleTypeData({ ...header, value: header.label })}
          </th>
        ))}
      </tr>
      {tableData?.headersRows >= 1 && (
        <tr>
          {tableData.headers.map((header) =>
            header.subCols?.map((subCol) => (
              <th
                key={subCol.label}
                className={header.headersClass || tableData.headersClass}
                colSpan={subCol.cols}
                style={header.style}
              >
                {subCol.label}
              </th>
            ))
          )}
        </tr>
      )}
    </thead>
    <tbody>
      {tableData.rows.map((row) => (
        <tr>
          {row.map((cell) => (
            <td
              key={cell.value?.name || cell.value}
              className={cell.rowsClass || tableData.rowsClass}
              colSpan={cell.cols || 1}
              rowSpan={cell.rows || 1}
              style={cell.style}
            >
              {handleTypeData({ ...cell })}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

export const handleChildrenWrapper = (value) => {
  if (!value || typeof value !== 'object') return null;

  return Object.keys(value).map((key) =>
    // eslint-disable-next-line no-use-before-define
    handleTypeData(value[key])
  );
};

export const handleValidation = (validation, name) => {
  // Guard clause for invalid validation object
  if (!validation || typeof validation !== 'object') {
    return null;
  }

  let YupValidator = null;
  const { type, value, required, min, max, matches, nullable } = validation;
  //   console.log('validation', validation);

  switch (type) {
    case 'wrapper':
      return handleValidation(value);
    case 'object':
      if (value && typeof value === 'object') {
        YupValidator = Yup.object().shape({
          ...Object.keys(value).reduce((acc, key) => {
            const nestedSchema = handleValidation(value[key], key);
            if (nestedSchema) {
              acc[key] = nestedSchema;
            }
            return acc;
          }, {}),
        });
      }
      return YupValidator;

    case 'array':
      if (value && typeof value === 'object') {
        // Recursively validate array items
        const itemSchema = handleValidation(value, name);
        YupValidator = Yup.array()
          .of(itemSchema)
          .min(required ? 1 : 0, `${name} must have at least one item`)
          .nullable();
      }
      return YupValidator;

    case 'string':
      YupValidator = Yup.string();
      if (required) YupValidator = YupValidator.required(`${name} is required`);
      if (min) YupValidator = YupValidator.min(min, `${name} must be at least ${min} characters`);
      if (max) YupValidator = YupValidator.max(max, `${name} must be at most ${max} characters`);
      if (matches) YupValidator = YupValidator.matches(matches, `${name} is invalid`);
      if (nullable) {
        YupValidator = YupValidator.nullable();
      }
      return YupValidator;

    case 'number':
      YupValidator = Yup.number();
      if (required) YupValidator = YupValidator.required(`${name} is required`);
      if (min) {
        YupValidator = YupValidator.min(min, `${name} must be at least ${min}`);
      }
      if (max) YupValidator = YupValidator.max(max, `${name} must be at most ${max}`);
      if (nullable) {
        YupValidator = YupValidator.nullable();
      }
      return YupValidator;

    case 'boolean':
      YupValidator = Yup.boolean();
      if (required) YupValidator = YupValidator.required(`${name} is required`);
      return YupValidator;

    case 'email':
      YupValidator = Yup.string()
        .email(`${name} must be a valid email`)
        .required(`${name} is required`);
      if (nullable) {
        YupValidator = YupValidator.nullable();
      }
      return YupValidator;

    default:
      return null;
  }
};

export const handleTypeData = (opts) => {
  const { type, value, class: className, tagName, func, style } = opts;

  let actualFunc = null;

  // func exec immediately
  switch (functions[func]) {
    case functions.calculateTotalPoints:
      functions[func](value);
      break;
    case functions.calculateOneColumnTotalBudget:
      functions[func](value);
      break;
    case functions.calculateOneRowTotalBudget:
      functions[func](value);
      break;
    default:
      actualFunc = functions[func];
      break;
  }

  switch (type) {
    case INPUT_TYPES.HTML:
      // eslint-disable-next-line react/no-danger
      return <div className={className} dangerouslySetInnerHTML={{ __html: value }} />;
    case INPUT_TYPES.TEXT_INPUT:
      return (
        <div className={className}>
          <TextInput
            placeholder={value.placeholder}
            label={value.label}
            isRequired={value.isRequired}
            control={control}
            errors={errors}
            name={value.name}
            defaultValue={value.defaultValue}
            readOnly={readOnly}
          />
        </div>
      );
    case INPUT_TYPES.COMBOBOX:
      return (
        <div className={className} onClick={() => (actualFunc ? actualFunc(value) : null)}>
          <Combobox
            label={value.label}
            name={value.name}
            control={control}
            errors={errors}
            isRequired={value.isRequired}
            defaultValue={value.defaultValue}
            readOnly={readOnly}
            options={value.options || []}
            placeholder={value.placeholder}
          />
        </div>
      );
    case INPUT_TYPES.CURRENCY_INPUT:
      return (
        <div className={className} onClick={() => (actualFunc ? actualFunc(value) : null)}>
          <CurrencyInput
            control={control}
            errors={errors}
            name={value.name}
            label={value.label}
            className={className}
            isRequired={value.isRequired}
            defaultValue={value.defaultValue}
            readOnly={readOnly}
          />
        </div>
      );
    case INPUT_TYPES.FILE_INPUT:
      return (
        <div className={className} onClick={() => (actualFunc ? actualFunc(value) : null)}>
          <input
            type="file"
            name={value.name}
            accept={value.accept || '*'}
            onChange={(e) => {
              if (actualFunc) {
                actualFunc(e.target.files);
              }
            }}
            disabled={readOnly}
          />
        </div>
      );
    case INPUT_TYPES.DATE_PICKER:
      return (
        <div className={className} onClick={() => (actualFunc ? actualFunc(value) : null)}>
          <DatePicker
            label={value.label}
            name={value.name}
            control={control}
            errors={errors}
            isRequired={value.isRequired}
            defaultValue={value.defaultValue}
            readOnly={readOnly}
            placeholder={value.placeholder}
          />
        </div>
      );
    case INPUT_TYPES.EDITOR_INPUT:
      return (
        <div className={className} onClick={() => (actualFunc ? actualFunc(value) : null)}>
          <HugerteEditor
            value={value.defaultValue}
            control={control}
            errors={errors}
            name={value.name}
            label={value.label}
            className={className}
            isRequired={value.isRequired}
            defaultValue={value.defaultValue}
            reset={reset}
            readOnly={readOnly}
          />
        </div>
      );
    case INPUT_TYPES.MASK_INPUT:
      return (
        <div className={className} onClick={() => (actualFunc ? actualFunc(value) : null)}>
          <MaskInput
            control={control}
            errors={errors}
            name={value.name}
            label={value.label}
            className={className}
            isRequired={value.isRequired}
            defaultValue={value.defaultValue}
            readOnly={readOnly}
          />
        </div>
      );
    case INPUT_TYPES.MULTIPLE_SELECT:
      return (
        <div className={className} onClick={() => (actualFunc ? actualFunc(value) : null)}>
          <MultipleSelect
            label={value.label}
            name={value.name}
            control={control}
            errors={errors}
            isRequired={value.isRequired}
            defaultValue={value.defaultValue}
            readOnly={readOnly}
            options={value.options || []}
            placeholder={value.placeholder}
          />
        </div>
      );
    case INPUT_TYPES.NUMBER_INPUT:
      return (
        <div className={className} onClick={() => (actualFunc ? actualFunc(value) : null)}>
          <NumberInput
            label={value.label}
            name={value.name}
            control={control}
            errors={errors}
            isRequired={value.isRequired}
            defaultValue={value.defaultValue || null}
            min={value.min}
            max={value.max}
            readOnly={readOnly}
          />
        </div>
      );
    case INPUT_TYPES.RADIO_INPUT:
      return (
        <div className={className} onClick={() => (actualFunc ? actualFunc(value) : null)}>
          <RadioInput
            label={value.label}
            name={value.name}
            control={control}
            errors={errors}
            isRequired={value.isRequired}
            defaultValue={value.defaultValue}
            readOnly={readOnly}
            options={value.options || []}
          />
        </div>
      );
    case INPUT_TYPES.TICK_BOX:
      return (
        <div className={className} onClick={() => (actualFunc ? actualFunc(value) : null)}>
          <Tickbox
            label={value.label}
            name={value.name}
            control={control}
            errors={errors}
            isRequired={value.isRequired}
            defaultValue={value.defaultValue}
            readOnly={readOnly}
          />
        </div>
      );
    case INPUT_TYPES.SELECT:
      return (
        <div className={className} onClick={() => (actualFunc ? actualFunc(value) : null)}>
          <Select
            label={value.label}
            name={value.name}
            control={control}
            errors={errors}
            isRequired={value.isRequired}
            defaultValue={value.defaultValue}
            readOnly={readOnly}
            options={value.options || []}
            placeholder={value.placeholder}
          />
        </div>
      );
    case INPUT_TYPES.TEXT_AREA_INPUT:
      return (
        <div className={className} onClick={() => (actualFunc ? actualFunc(value) : null)}>
          <TextareaInput
            label={value.label}
            name={value.name}
            control={control}
            errors={errors}
            isRequired={value.isRequired}
            defaultValue={value.defaultValue}
            readOnly={readOnly}
            placeholder={value.placeholder}
          />
        </div>
      );
    case INPUT_TYPES.REPLACE:
      return handleTagName(
        tagName,
        className,
        getValueByPath(existedData, value),
        actualFunc,
        value
      );
    case INPUT_TYPES.WRAPPER:
      return handleTagName(tagName, className, handleChildrenWrapper(value), actualFunc, value);
    case INPUT_TYPES.TABLE:
      return handleTable(value, className, style);
    case INPUT_TYPES.SIGNATURE:
      return (
        <div className={className} onClick={() => (actualFunc ? actualFunc(value) : null)}>
          <Signature
            refetchReviewerInfo={refetchReviewerInfo}
            reviewerInfo={reviewerInfo}
            readOnly={readOnly}
          />
        </div>
      );
    default: // text
      return handleTagName(tagName, className, value);
  }
};

export const calculateTotalScore = (data) => {
  if (!data || typeof data !== 'object') return 0;
  let totalScore = 0;
  const result = data;
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (typeof value === 'number') {
      totalScore += value;
    } else if (typeof value === 'object' && value !== null) {
      totalScore += calculateTotalScore(value);
    }
  });
  if (typeof totalScore !== 'number') {
    totalScore = 0;
    Object.keys(data).forEach((key) => {
      if (data[key]?.totalScore) {
        totalScore += data[key].totalScore;
      }
    });
  }
  if (totalScore > 100) {
    totalScore = 100;
  }
  result.totalScore = totalScore;
  return result;
};
